import { Tooltip } from '@roo/roo'
import React, { CSSProperties, ReactElement } from 'react'

const TipText = (props: { text: string | ReactElement, placement?: 'top' | 'bottom', style?: CSSProperties }) => (
  <Tooltip content={props.text} placement={props.placement}>
    <span style={{ width: '100%', textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', display: 'inline-block', ...(props.style || {}) }}>
      {props.text}
    </span>
  </Tooltip>
)
export default TipText